const { Keywords } = require("@hyperjump/json-schema-core");


module.exports = {
  additionalItems: require("./additionalItems"),
  additionalItems6: require("./additionalItems6"),
  additionalProperties: require("./additionalProperties"),
  additionalProperties6: require("./additionalProperties6"),
  allOf: require("./allOf"),
  anyOf: require("./anyOf"),
  const: require("./const"),
  contains: require("./contains"),
  containsMinContainsMaxContains: require("./contains-minContains-maxContains"),
  definitions: require("./definitions"),
  dependencies: require("./dependencies"),
  dependentRequired: require("./dependentRequired"),
  dependentSchemas: require("./dependentSchemas"),
  enum: require("./enum"),
  exclusiveMaximum: require("./exclusiveMaximum"),
  exclusiveMinimum: require("./exclusiveMinimum"),
  if: require("./if"),
  then: require("./then"),
  else: require("./else"),
  items: require("./items"),
  items202012: require("./items202012"),
  maxItems: require("./maxItems"),
  maxLength: require("./maxLength"),
  maxLength6: require("./maxLength6"),
  maxProperties: require("./maxProperties"),
  maximumExclusiveMaximum: require("./maximum-exclusiveMaximum"),
  maximum: require("./maximum"),
  metaData: Keywords.metaData,
  minItems: require("./minItems"),
  minLength: require("./minLength"),
  minLength6: require("./minLength6"),
  minProperties: require("./minProperties"),
  minimumExclusiveMinimum: require("./minimum-exclusiveMinimum"),
  minimum: require("./minimum"),
  multipleOf: require("./multipleOf"),
  not: require("./not"),
  oneOf: require("./oneOf"),
  pattern: require("./pattern"),
  patternProperties: require("./patternProperties"),
  properties: require("./properties"),
  propertyNames: require("./propertyNames"),
  dynamicRef: require("./dynamicRef"),
  ref: require("./ref"),
  required: require("./required"),
  tupleItems: require("./tupleItems"),
  type: require("./type"),
  unevaluatedItems: require("./unevaluatedItems"),
  unevaluatedProperties: require("./unevaluatedProperties"),
  uniqueItems: require("./uniqueItems"),
  validate: Keywords.validate
};
